import { getAnalyticsIdentity } from "./analytics-identity";

const TRACK_URL = "/api/track";
export const GOOGLE_ANALYTICS_ID = "G-LCVFQXRMDC";
let researchPrivacyActive = false;
let previousGoogleOptOut;

export function configureResearchPrivacy(pathname) {
  if (typeof window === "undefined") return;
  const key = `ga-disable-${GOOGLE_ANALYTICS_ID}`;
  if (pathname.startsWith("/vote-ready")) {
    if (!researchPrivacyActive) {
      previousGoogleOptOut = Object.prototype.hasOwnProperty.call(
        window,
        "__ngelReadinessGaBaseline",
      )
        ? window.__ngelReadinessGaBaseline
        : window[key];
      delete window.__ngelReadinessGaBaseline;
      researchPrivacyActive = true;
    }
    window[key] = true;
  } else if (researchPrivacyActive) {
    if (previousGoogleOptOut === undefined) delete window[key];
    else window[key] = previousGoogleOptOut;
    researchPrivacyActive = false;
  }
}

export function withShareUtm(baseUrl, medium) {
  const hashIndex = baseUrl.indexOf("#");
  const pre = hashIndex === -1 ? baseUrl : baseUrl.slice(0, hashIndex);
  const hash = hashIndex === -1 ? "" : baseUrl.slice(hashIndex);
  const separator = pre.includes("?") ? "&" : "?";
  return `${pre}${separator}utm_source=${medium}&utm_medium=share${hash}`;
}

export function getLandingContext() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem("ngel_landing");
    if (raw) return JSON.parse(raw);
    const ctx = {
      path: window.location.pathname,
      referrer: document.referrer || null,
    };
    window.sessionStorage.setItem("ngel_landing", JSON.stringify(ctx));
    return ctx;
  } catch {
    return null;
  }
}

function sendBeacon(payload) {
  if (typeof window === "undefined") return;
  // Lets the rollup separate real traffic from previews and local runs.
  const body = JSON.stringify({
    ...payload,
    siteHost: window.location.hostname,
  });
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(TRACK_URL, blob);
      return;
    }
  } catch {}
  try {
    fetch(TRACK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {}
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (window.gtag && !window.location.pathname.startsWith("/vote-ready")) {
    window.gtag("event", name, params);
  }
  sendBeacon({
    name,
    ...getAnalyticsIdentity(name),
    path: window.location.pathname,
    referrer: document.referrer || null,
    properties: params,
  });
}

export function trackPageview() {
  if (typeof window === "undefined") return;
  getLandingContext();
  sendBeacon({
    name: "pageview",
    ...getAnalyticsIdentity("pageview"),
    path: window.location.pathname,
    referrer: document.referrer || null,
    properties: window.location.search
      ? { search: window.location.search }
      : null,
  });
}

const SCROLL_BUCKETS = [25, 50, 75, 100];
let scrollSeen = new Set();
let engagementInstalled = false;

function onScroll() {
  const doc = document.documentElement;
  const denom = doc.scrollHeight - doc.clientHeight;
  if (denom <= 0) return;
  const pct = Math.min(
    100,
    Math.round(((window.scrollY || doc.scrollTop) / denom) * 100),
  );
  for (const b of SCROLL_BUCKETS) {
    if (pct >= b && !scrollSeen.has(b)) {
      scrollSeen.add(b);
      trackEvent("scroll_depth", { depth: b });
    }
  }
}

function onDocClick(e) {
  const link = e.target.closest && e.target.closest("a[href]");
  if (!link) return;
  // Inline research measures source use with a fixed event, not a destination
  // URL that could reconstruct a reader's candidate/source selections.
  if (link.closest("[data-private-research]")) return;
  const raw = link.getAttribute("href");
  if (!raw || raw.startsWith("/") || raw.startsWith("#")) return;
  try {
    const url = new URL(raw, window.location.origin);
    if (!["http:", "https:"].includes(url.protocol)) return;
    if (url.hostname === window.location.hostname) return;
    trackEvent("outbound_click", { href: url.href, host: url.hostname });
  } catch {}
}

export function installEngagementTracking() {
  if (typeof window === "undefined" || engagementInstalled) return;
  window.addEventListener("scroll", onScroll, { passive: true });
  document.addEventListener("click", onDocClick);
  engagementInstalled = true;
}

export function resetScrollDepthForRoute() {
  scrollSeen = new Set();
}
